import { Statuses } from "utils/InterfaceAndTypeGeneral";

export const messages = {
  [Statuses.IN_PROGRESS]: [
    {
      id: "message-1",
      text: `Reanuda tu examen desde donde lo dejaste.`,
      highlight: "",
      continuation: ``,
    },
    {
      id: "message-2",
      text: `Recuerda que  `,
      highlight: "el tiempo sigue corriendo."
    },
  ],
  [Statuses.NOT_DELIVERED]: [
    {
      id: "message-3",
      text: `Al hacer clic en `,
      highlight: "“Rendir examen”",
      continuation: `, iniciará el tiempo de duración y no se detendrá.`,
    },
    {
      id: "message-4",
      text: `Si termina el tiempo, se enviarán las respuestas hasta donde avanzaste.`,
      highlight: ''
    },
  ],
  [Statuses.SCHEDULED]: [
    {
      id: "message-5",
      text: `El examen se activará en la fecha y hora señalada.`,
      highlight: ''
    },
  ],
};
